<ngb-toast *ngFor="let toast of toastService.toasts" [autohide]="true" [class]="toast.classname"
           [delay]="toast.delay || 5000" class="position-absolute w-50 mx-auto text-center fs-6 fw-bold">
  <ng-template [ngIfElse]="text" [ngIf]="isTemplate(toast)">
    <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
  </ng-template>

  <ng-template #text>{{ toast.textOrTpl }}</ng-template>
</ngb-toast>
